import React from 'react';
import c from 'classnames';
import { t } from 'i18next';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { WysiwygField, Button } from '../../../components';
import useWhatsappLink from '../../../helpers/useWhatsappLink';

import { ParagraphContactEntity } from '../../../types/paragraphs';
import './style.scss';

interface ParagraphContactProps extends React.HTMLProps<React.HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<ParagraphContactEntity>;
}

const ParagraphContact: React.FC<ParagraphContactProps> = ({ entity, className }) => {
  const paragraph = entity.toJS();
  const buttonLink = useWhatsappLink(
    paragraph.field_whatsapp_number && paragraph.field_whatsapp_number[0]?.value,
    paragraph.field_whatsapp_text && paragraph.field_whatsapp_text[0]?.value,
  );
  const buttonTitle = t('whatsapp_link.long');

  return (
    <div className={c('Paragraph ParagraphContact', className)}>
      <h2 className="ParagraphContact__title">
        {paragraph.field_title[0].value}
      </h2>
      {paragraph.field_text[0] ? (
        <WysiwygField
          property="schema:text"
          className="ParagraphContact__text"
          html={paragraph.field_text[0].processed}
        />
      ) : null}

      <Button
        href={buttonLink}
        className="ParagraphContact__button"
        title={buttonTitle}
        icon="whatsapp"
        type="secondary"
      >
        {t('whatsapp_link.long')}
      </Button>
    </div>
  );
};

export default ParagraphContact;
